import React from 'react'
import {
  BaseForm,
  Input,
  Select,
  DateRangePicker,
  VALIDATION_TYPES,
} from 'components/Form'
import { getMessage } from 'lib/translator'
import { MEDIA_AUDIT_LOG_ACTIONS, MEDIA_AUDIT_LOG_STATUSES } from '../constants'

const FORM_KEYS = {
  sku: 'sku',
  userId: 'userId',
  status: 'status',
  action: 'action',
  dates: 'dates',
}

export default class MediaAuditLogsFilter extends BaseForm {
  render() {
    const { SubmitButton, ClearButton } = this.buttons
    const { Form } = this.components
    const statusOptions = MEDIA_AUDIT_LOG_STATUSES.map((status) => ({
      text: status,
      value: status,
    }))
    const actionOptions = MEDIA_AUDIT_LOG_ACTIONS.map((action) => ({
      text: action,
      value: action,
    }))

    return (
      <Form className="sku-media-audit-filter-form">
        <div className="form-fields date-fields sku-media-audit-filters">
          <Input
            name={FORM_KEYS.sku}
            label={getMessage('catalogue.skuMediaUpload.auditLogs.filter.sku')}
            placeholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.sku.placeholder'
            )}
            {...this.generateStateMappers({
              stateKeys: [FORM_KEYS.sku],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
          />
          <Input
            name={FORM_KEYS.userId}
            label={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.userId'
            )}
            placeholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.userId.placeholder'
            )}
            {...this.generateStateMappers({
              stateKeys: [FORM_KEYS.userId],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
          />
          <Select
            name={FORM_KEYS.status}
            label={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.status'
            )}
            placeholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.status.placeholder'
            )}
            options={statusOptions}
            {...this.generateStateMappers({
              stateKeys: [FORM_KEYS.status],
              defaultValue: '',
            })}
          />
          <Select
            name={FORM_KEYS.action}
            label={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.action'
            )}
            placeholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.action.placeholder'
            )}
            options={actionOptions}
            {...this.generateStateMappers({
              stateKeys: [FORM_KEYS.action],
              defaultValue: '',
            })}
          />
          <DateRangePicker
            className="section-row-input"
            label={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.dateRange'
            )}
            placeholder={getMessage('datetime.date')}
            displayFormat="YYYY-MM-DD"
            minimumNights={0}
            isOutsideRange={() => false}
            startDatePlaceholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.dateFrom.placeholder'
            )}
            endDatePlaceholder={getMessage(
              'catalogue.skuMediaUpload.auditLogs.filter.dateTo.placeholder'
            )}
            withPortal
            {...this.generateStateMappers({
              stateKeys: [FORM_KEYS.dates],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
          />
        </div>
        <SubmitButton>
          {getMessage('catalogue.skuMediaUpload.auditLogs.filter.submit')}
        </SubmitButton>
        <ClearButton>
          {getMessage('catalogue.skuMediaUpload.auditLogs.filter.clear')}
        </ClearButton>
      </Form>
    )
  }
}
